import { useQuery } from '@tanstack/react-query';
import { fetchHistoricoUpload } from '../api/HistoricoUploadApi';

export function useHistoricoUpload(periodo: number, cnpj: string, enabled: boolean) {
  return useQuery({
    queryKey: ['historico-upload', periodo, cnpj],
    queryFn: () => fetchHistoricoUpload(periodo, cnpj),
    enabled,
    staleTime: 0,
  });
}
